import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { style: {"display":"flex","align-items":"center","gap":"10px","width":"100%"} }

import { ref, computed } from 'vue';
import {
  BaseForm,
  BaseButton,
  BaseTextContent,
  XrkMessage,
  BaseDialog,
  BaseFormItem,
  BaseSelect
} from 'xrk-components';
import { getInvoiceItem, getInvoiceSubItem } from '../../data-source/apis';
import { GetInvoiceItemDataItem } from '../../data-source/types';


export default /*#__PURE__*/_defineComponent({
  __name: 'add-category-dialog',
  props: {
    remove: {},
    invoiceItemIdList: {}
  },
  emits: ['success'],
  setup(__props: any, { emit: __emit }) {

const emits = __emit;
const props = __props;

const invoiceAjax: Record<number, typeof getInvoiceItem> = {
  1: getInvoiceItem,
  2: getInvoiceSubItem
};

const formRef = ref();
const formData = ref<GetInvoiceItemDataItem>({
  id: null,
  code: '',
  topLevelCategory: '',
  subcategory: '',
  label: '',
  value: null,
  disabled: false,
  subItem: [{ id: null, name: '' }],
  name: null
});

const isValid = computed(() => {
  return (
    formData.value.id != null &&
    formData.value.subItem.length > 0 &&
    formData.value.subItem.every(s => s.id != null)
  );
});

// 所有二级类目都已填写才能新增下一行
const canAddSubItem = computed(() =>
  formData.value.subItem.every(s => s.id != null)
);

// 一级类目已选 ID 集合
const selectedIds1 = computed(() =>
  props.invoiceItemIdList.map(item => item.id)
);

const getInvoiceItemRemoteMethod = async (
  val: string,
  type: 1 | 2,
  subIndex?: number
) => {
  const resp = await invoiceAjax[type]({
    keyword: val,
    ...(formData.value.id && { itemId: formData.value.id })
  });

  if (type === 1) {
    const taken = new Set(selectedIds1.value);
    resp.data.forEach(item => {
      if (taken.has(item.id)) item.disabled = true;
    });
  } else if (type === 2 && subIndex !== undefined) {
    const taken = new Set<number>();
    // 已有 invoiceItemIdList 中的二级类目
    props.invoiceItemIdList.forEach(item => {
      if (item.subItem) {
        item.subItem.forEach(s => taken.add(s.id));
      }
    });
    // 当前对话框中其他行的已选值
    formData.value.subItem.forEach((s, i) => {
      if (i !== subIndex && s.id != null) taken.add(s.id);
    });
    resp.data.forEach(item => {
      if (taken.has(item.id)) item.disabled = true;
    });
  }

  return resp;
};

const onInvoiceItemChange = (val, [option]) => {
  formData.value = {
    ...option,
    subItem: [{ id: null, name: '' }]
  };
};

const onSubItemChange = (index: number, option) => {
  formData.value.subItem[index] = { id: option.id, name: option.name };
};

const addSubItem = () => {
  formData.value.subItem.push({ id: null, name: '' });
};

const removeSubItem = (index: number) => {
  formData.value.subItem.splice(index, 1);
};

const onCancel = () => {
  props.remove();
};

const onConfirm = async () => {
  XrkMessage.success('操作成功');
  emits('success', formData.value);
  onCancel();
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(BaseDialog), {
    width: "650px",
    title: "新增类目",
    "model-value": true,
    "show-close": true,
    "close-on-press-escape": true,
    "close-on-click-modal": false,
    "show-footer": false
  }, {
    footer: _withCtx(() => [
      _createVNode(_unref(BaseButton), {
        type: "default",
        onClick: onCancel
      }, {
        default: _withCtx(() => [
          _createTextVNode("取消")
        ]),
        _: 1
      }),
      _createVNode(_unref(BaseButton), {
        type: "primary",
        disabled: !isValid.value,
        click: onConfirm
      }, {
        default: _withCtx(() => [
          _createTextVNode(" 保存 ")
        ]),
        _: 1
      }, 8, ["disabled"])
    ]),
    default: _withCtx(() => [
      _createVNode(_unref(BaseTextContent), null, {
        default: _withCtx(() => [
          _createVNode(_unref(BaseForm), {
            ref_key: "formRef",
            ref: formRef,
            "label-position": "right",
            model: formData.value
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(BaseFormItem), {
                label: "一级类目",
                prop: "id",
                rules: [{ required: true, trigger: 'change', message: '请选择' }]
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(BaseSelect), {
                    placeholder: "请选择",
                    modelValue: formData.value.id,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.value.id) = $event)),
                    filterUseRemote: true,
                    init: true,
                    remoteMethod: val => getInvoiceItemRemoteMethod(val, 1),
                    onChange: onInvoiceItemChange
                  }, null, 8, ["modelValue", "remoteMethod"])
                ]),
                _: 1
              }),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(formData.value.subItem, (subItem, index) => {
                return (_openBlock(), _createBlock(_unref(BaseFormItem), {
                  key: index,
                  label: 
            formData.value.subItem.length > 1 ? '二级类目' + (index + 1) : '二级类目'
          ,
                  prop: 'subItem.' + index + '.id',
                  rules: [{ required: true, trigger: 'change', message: '请选择' }]
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_1, [
                      _createVNode(_unref(BaseSelect), {
                        style: {"flex":"1"},
                        placeholder: "请选择",
                        labelKey: "name",
                        valueKey: "id",
                        disabled: !formData.value.id,
                        filterUseRemote: true,
                        init: false,
                        remoteMethod: val => getInvoiceItemRemoteMethod(val, 2, index),
                        modelValue: subItem.id,
                        "onUpdate:modelValue": ($event: any) => ((subItem.id) = $event),
                        onChange: (val, [option]) => onSubItemChange(index, option)
                      }, null, 8, ["disabled", "remoteMethod", "modelValue", "onUpdate:modelValue", "onChange"]),
                      (formData.value.subItem.length > 1)
                        ? (_openBlock(), _createBlock(_unref(BaseButton), {
                            key: 0,
                            type: "text",
                            onClick: ($event: any) => (removeSubItem(index))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(" 删除 ")
                            ]),
                            _: 2
                          }, 1032, ["onClick"]))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _: 2
                }, 1032, ["label", "prop"]))
              }), 128)),
              _createVNode(_unref(BaseButton), {
                type: "text",
                onClick: addSubItem,
                disabled: !formData.value.id || !canAddSubItem.value
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" 添加二级类目 ")
                ]),
                _: 1
              }, 8, ["disabled"])
            ]),
            _: 1
          }, 8, ["model"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})